var _style, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKettlebellSwings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#273851;}\n\t.st1{fill:#EE8F60;}\n\t.st2{fill:#EFC05D;}\n\t.st3{fill:#FFFFFF;}\n\t.st4{fill:#FFD881;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.4,183.78c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C30.11,149.49,64.71,183.78,107.4,183.78"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M136.29,95.46V80.71c0-9.94-8.14-18.08-18.08-18.08H96.6c-9.94,0-18.08,8.14-18.08,18.08v14.75 c-5.9,6.75-9.48,15.57-9.48,25.23c0,11.28,4.87,21.41,12.62,28.43c1.84,1.67,4.23,2.61,6.71,2.61h38.07 c2.48,0,4.87-0.94,6.71-2.61c7.75-7.02,12.62-17.15,12.62-28.43C145.76,111.03,142.18,102.21,136.29,95.46z M126.97,90.27 c-5.73-3.4-12.42-5.37-19.57-5.37c-7.15,0-13.84,1.96-19.57,5.37v-9.02c0-5.44,4.45-9.9,9.9-9.9h19.33c5.45,0,9.9,4.46,9.9,9.9 V90.27z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 107.4,
    cy: 120.79,
    r: 18.56
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M88.84,145.21c-0.27,0-0.54-0.09-0.77-0.27c-2.2-1.77-4.15-3.82-5.8-6.11c-0.4-0.55-0.27-1.33,0.28-1.73 c0.55-0.4,1.33-0.27,1.73,0.28c1.52,2.11,3.31,4,5.34,5.62c0.53,0.43,0.62,1.21,0.19,1.74C89.56,145.06,89.2,145.21,88.84,145.21z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M79.51,132.26c-0.5,0-0.98-0.31-1.16-0.81c-1.25-3.41-1.88-6.99-1.88-10.65c0-6.38,1.93-12.51,5.57-17.72 c0.39-0.56,1.16-0.7,1.72-0.3c0.56,0.39,0.7,1.16,0.3,1.72c-3.35,4.79-5.12,10.43-5.12,16.3c0,3.37,0.58,6.67,1.73,9.8 c0.24,0.64-0.09,1.35-0.74,1.59C79.8,132.24,79.65,132.26,79.51,132.26z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M99.97,92.3c0,0.03-0.02,0.06-0.06,0.06l0,0H99.8c-0.03,0-0.05-0.03-0.05-0.06c0-0.04,0.02-0.06,0.05-0.06h0.11 C99.94,92.24,99.97,92.26,99.97,92.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKettlebellSwings);
export default __webpack_public_path__ + "static/media/Kettlebell_swings.b91fe23bfc3b17330919e7301c682844.svg";
export { ForwardRef as ReactComponent };